/* Components */
import Header from "../../components/common/Header";
import Icon from "../../components/common/Icon";
import {Link} from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import {safeJwtDecode} from "../../helper/jwtHelper";
import {getAgencyUserList, setUserEnabled} from "../../api/admin/userReq";
import {useEffect, useState} from "react";
import FormUserInfos from "../../forms/admin/FormUserInfos";
import {capitalize} from "../../helper/tools";


export default function Coworkers() {
    const sources = [ "fas fa-users" ];
    const {auth} = useAuth();
    const token = auth.token;
    const decodedToken = safeJwtDecode(token);
    const agencyId = decodedToken?.agency;
    const [coworkers, setCoworkers] = useState();
    const [showModal, setShowModal] = useState(false);

    const apiCoworkers = async () => {
        const response = await getAgencyUserList(token, agencyId)
        setCoworkers(response)
    }

    const handleCoworkerEnable = (e) => {
        e.preventDefault();
        if (!auth.roles.includes("ROLE_PF" && "ROLE_UPF" && "ROLE_PREVIOUS_ADMIN")) {
            alert("Vous n'avez pas les droits pour modifier la visibilité d'un utilisateur.");
        } else {
            const userId = parseInt(e.currentTarget.getAttribute("id"));
            const currentIsEnabled = e.currentTarget.classList.contains("fa-eye");

            if (currentIsEnabled) {
                let body = {
                    "userId": userId,
                    "userEnabled": false,
                }
                alert("Vous venez de désactiver cet utilisateur.");
                setUserEnabled(token, body)
            } else {
                let body = {
                    "userId": userId,
                    "userEnabled": true,
                }
                alert("Vous venez d'activer cet utilisateur.");
                setUserEnabled(token, body)
            }
        }
    };

    useEffect(() => {
        apiCoworkers()
    }, [token]);

    const handleCoworkerForm = () => {
        setShowModal(true)
    }

    return (
        <main>
            <Header
                location="Liste des collaborateurs"
                parent="Tableau de bord"
                slug="/"
            />
            {showModal &&
                <div className="modal user-infos">
                    <FormUserInfos apiUserInfos={apiCoworkers} workerId={0} setShowModal={setShowModal} legend="Ajout d'un collaborateur"/>
                </div>
            }
                <div className="content-container">
                    <Icon source="fa fa-users" span="Mes collaborateurs"/>
                    <div>
                    <table>
                        <thead className="dashboard-header">
                            <tr>
                                <th>Nom</th>
                                <th>Prénom</th>
                                <th>Identifiant</th>
                                <th>Email</th>
                                <th>Statut</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                        {coworkers?.map(coworker => (
                            <tr>
                                <td>{capitalize(coworker?.lastName)}</td>
                                <td>{capitalize(coworker?.firstName)}</td>
                                <td>{coworker?.username}</td>
                                <td>{coworker?.email}</td>
                                <td>
                                    <i
                                        id={coworker?.id}
                                        className={coworker?.enabled ? "fa fa-eye" : "fa fa-eye-slash"}
                                        onClick={handleCoworkerEnable}
                                        title={coworker?.enabled ? "Collaborateur actif - Cliquer pour désactiver" : "Collaborateur inactif - Cliquer pour activer"}
                                    />
                                </td>
                                <td className="actions">
                                    <Link to={`/agence/collaborateurs/${coworker?.id}/voir`} title="Modifier le collaborateur">
                                        <i className="fa fa-gear"/>
                                    </Link>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="flex-buttons">
            <button onClick={handleCoworkerForm}><i className="fa fa-plus"/><span>Ajouter un collègue</span></button>
            </div>
        </main>
    )
}